import * as allActions from "./actions";
import * as allConstants from "./constants";

export const actions = allActions;
export const constants = allConstants;
